
<b-modal
  centered
  ref="editVendorRequestPart"
  id="editVendorRequestPart"
  body-class="modal-body-wo"
  hide-footer
  hide-header
  size="xl"
  title="Edit Part"
  :no-enforce-focus="true"
  @hidden="modalClosed"
  :no-close-on-backdrop="true"
>
  <modal-window main-width="12">
    <h1>Edit part for vendor request</h1>
    <div class="row mt-3">
      <div class="col-5">
        <div class="label">Vendor</div>
      </div>
      <div class="col-7">
        <div>{{ vendorRequestPart.vendorName }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="label">Part</div>
      </div>
      <div class="col-7">
        <div>{{ vendorRequestPart.part.pn }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-5">
        <div class="label">Quantity</div>
      </div>
      <div class="col-7">
        <div>{{ vendorRequestPart.quantityRequested }}</div>
      </div>
    </div>
    <b-tabs>
      <b-tab title="Request">
        <EditVendorRequestPartRequest @close="cancel" @saved="cancel"></EditVendorRequestPartRequest>
      </b-tab>
      <b-tab title="Order / Shipment">
        <EditVendorRequestPartOrder @close="cancel" @saved="cancel"></EditVendorRequestPartOrder>
      </b-tab>
    </b-tabs>
    <template #sidebar></template>
  </modal-window>
</b-modal>
